import * as React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost' | 'destructive';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'default', size = 'default', ...props }, ref) => {
    let baseClasses = 'btn';

    // Variant styles
    if (variant === 'default') {
      baseClasses += ' btn-primary';
    } 
    else if (variant === 'outline') {
      baseClasses += ' border bg-white text-gray-900 hover:bg-gray-50';
    } 
    else if (variant === 'ghost') {
      baseClasses += ' bg-transparent text-gray-900 hover:bg-gray-50';
    }
    else if (variant === 'destructive') {
      baseClasses += ' bg-red-600 text-white hover:bg-red-700'; // 🔥 ADDED
    }

    // Size styles
    if (size === 'sm') {
      baseClasses += ' text-sm px-3 py-1';
    } 
    else if (size === 'lg') {
      baseClasses += ' text-lg px-6 py-3';
    } 
    else if (size === 'icon') {
      baseClasses += ' w-10 h-10 p-0';
    }

    return (
      <button
        className={`${baseClasses} ${className}`}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button };
